export default __webpack_public_path__ + "static/media/icn-home-active.173aec3e.svg";